import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import superagent from 'superagent';
import {saveAs} from '../util/saveAs';

export const downloadPDF = createAsyncThunk(
	'status/pdfLoading',
	(options, {getState}) =>
		superagent
			.get(`${getState().status.expressUrl}/pdf?region=${getState().status.region}&lang=${getState().status.lang}&family=${getState().status.family}&mode=${getState().status.mode}&key=${getState().status.shortKey}`)
			.set('X-SESSION-ID', getState().session.sessionId)
			.responseType('blob')
			.then((response) => response.body)
			.catch((error) => error)
);
export const downloadPNG = createAsyncThunk(
	'status/pngLoading',
	(options, {getState}) =>
		superagent
			.get(`${getState().status.expressUrl}/png?region=${getState().status.region}&lang=${getState().status.lang}&family=${getState().status.family}&mode=${getState().status.mode}&key=${getState().status.shortKey}`)
			.set('X-SESSION-ID', getState().session.sessionId)
			.responseType('blob')
			.then((response) => response.body)
			.catch((error) => error)
);
export const downloadRelux = createAsyncThunk(
	'status/reluxLoading',
	(options, {getState}) =>
		superagent
			.get(`${getState().status.expressUrl}/relux?key=${getState().status.shortKey}&lang=${getState().status.lang}`)
			.set('X-SESSION-ID', getState().session.sessionId)
			.responseType('blob')
			.then((response) => response.body)
			.catch((error) => error)
);
const downloadInitialState = {
	status: 'idle',
	statusPng: 'idle',
	error: {}
};
export const downloadSlice = createSlice({
	name: 'download',
	initialState: downloadInitialState,
	reducers: {
	},
	extraReducers: (builder) => {
		builder.addCase(downloadPDF.fulfilled, (state, action) => {
			console.log('downloadPDF', action, state);
			saveAs(action.payload, 'selux-specsheet.pdf', 'application/pdf');
			state.status = 'idle';
			state.error = {};
		});
		builder.addCase(downloadPDF.pending, (state, action) => {
			state.status = 'loading';
			state.error = {};
		});
		builder.addCase(downloadPDF.rejected, (state, action) => {
			state.status = 'idle';
			state.error = 'error';
		});
		builder.addCase(downloadPNG.fulfilled, (state, action) => {
			console.log('downloadPNG', action, state);
			saveAs(action.payload, 'selux-productimage.png', 'image/png');
			state.statusPng = 'idle';
			state.error = {};
		});
		builder.addCase(downloadPNG.pending, (state, action) => {
			state.statusPng = 'loading';
			state.error = {};
		});
		builder.addCase(downloadPNG.rejected, (state, action) => {
			state.statusPng = 'idle';
			state.error = 'error';
		});
		builder.addCase(downloadRelux.fulfilled, (state, action) => {
			console.log('downloadRelux', action, state);
			saveAs(action.payload, 'line-specsheet.Relux', 'application/json');
			state.status = 'idle';
			state.error = {};
		});
		builder.addCase(downloadRelux.pending, (state, action) => {
			state.status = 'loading';
			state.error = {};
		});
		builder.addCase(downloadRelux.rejected, (state, action) => {
			state.status = 'idle';
			state.error = 'error';
		});
	}
});


export const {

} = downloadSlice.actions;


export default downloadSlice.reducer;
